import { useModules } from '@entities/common/modules';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '@shared/hooks';

import { openOutModal } from 'library/redux/modal';

const useMenuLinks = () => {
	const [showMenu, setShowMenu] = useState<boolean>(false);

	const handleLogout = () => {
		setShowMenu(false);
		dispatch(openOutModal());
	};

	const staticLinks = [
		// {
		// 	link: '/personal',
		// 	title: 'Профиль',
		// 	code: 'profile',
		// 	onClick: () => handleButtonClick('/personal'),
		// },
		{
			link: '',
			title: 'Выход',
			code: 'exit',
			onClick: () => handleLogout(),
		},
	];

	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const { modules } = useModules();

	// модули главного меню
	const sortedModules = modules
		?.filter((module) => module.menu_type === 'main')
		.sort((a, b) => a.order - b.order);

	// модули дополнительного меню
	const userModules = modules
		?.filter((module) => module.menu_type === 'user')
		.sort((a, b) => a.order - b.order);

	const handleButtonClick = (link: string) => {
		setShowMenu(false);
		navigate(link);
	};

	const hideMenu = () => {
		setShowMenu(false);
	};

	const toggleMenu = () => {
		setShowMenu((show) => !show);
	};

	const showCart = () => {
		return modules.find((module) => module.code === 'store');
	};

	const showStatistics = () => {
		return modules.find((module) => module.module_type === 'statistics');
	};

	return {
		modules: sortedModules,
		userModules: userModules ? userModules : [],
		sortedModules: sortedModules ? sortedModules : [],
		showMenu,
		handleButtonClick,
		hideMenu,
		toggleMenu,
		handleLogout,
		staticLinks,
		setShowMenu,
		showCart: showCart(),
		showStatistics: showStatistics(),
	};
};

export default useMenuLinks;
